import React, { useState } from "react";
import {
  Modal,
  Paper,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { postSendEmailURL } from "../../utils/ConstantsURL";
import { toastAlert } from "../../utils/AlertContext";

export const ContentCarvajal = ({ token, open, close, idDocument }) => {
  const [loadingUser, setLoadingUser] = useState(false);
  const [loadingClient, setLoadingClient] = useState(false);

  const handleUpdate = async (selectedOption) => {
    const setLoading = selectedOption === "user" ? setLoadingUser : setLoadingClient;
    setLoading(true);
    
    try {
      const response = await fetch(postSendEmailURL(idDocument, selectedOption), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        toastAlert("Correo enviado con éxito", "success", 4000);
      } else {
        toastAlert("Error al enviar el correo", "error", 4000);
      }
    } catch (error) {
      toastAlert("Error al enviar el correo", "error", 4000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={3}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          width: "70%",
          overflowY: "auto",
          outline: "none",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Typography variant="h6">Enviar Correo Carvajal</Typography>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </div>

        <Typography variant="h6">
          ¿Desea enviar un correo electrónico?
        </Typography>
        <Typography variant="subtitle1" style={{ margin: '10px 0' }}>
          Esta acción se completará al presionar el botón seleccionado.
        </Typography>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <LoadingButton
            variant="contained"
            color="primary"
            onClick={() => handleUpdate("user")}
            loading={loadingUser}
            style={{
              marginRight: "10px",
            }}
          >
            Enviar Preview
          </LoadingButton>
          <LoadingButton
            variant="contained"
            color="primary"
            onClick={() => handleUpdate("client")}
            loading={loadingClient}
          >
            Enviar a Clientes
          </LoadingButton>
        </div>
      </Paper>
    </Modal>
  );
};
